import Api from "@/config/Api";

export default {
  getCities() {
    return Api().get("/cities", {});
  }
};
